import { createIcon } from './create-icon'

export const BookmarkEmpty = createIcon({
  displayName: 'BookmarkEmpty',
  paths: [
    'M768 800.73l-256.853-128.128-255.147 127.872v-629.802h512v630.058zM768 85.338h-512c-47.104 0-85.333 38.187-85.333 85.333v698.879c0 24.747 20.309 42.752 42.667 42.752 6.357 0 12.843-1.451 19.115-4.608l278.784-139.691 280.405 139.861c6.229 3.115 12.715 4.565 19.029 4.565 22.357 0 42.667-18.005 42.667-42.709v-699.050c0-47.147-38.229-85.333-85.333-85.333z'
  ]
})
